import { axiosV1 } from 'interceptors/axios';
import { Dispatch } from 'redux';
import { ApiQueryParams } from 'types/ApiQueryParams';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

type GetHoldingClassSharesProps = {
  holdingClassId: string;
  params: ApiQueryParams;
};

export const getHoldingClassShares =
  ({ holdingClassId, params }: GetHoldingClassSharesProps) =>
  async (dispatch: Dispatch) => {
    const query = { params: { holdingClassId, ...params } };

    try {
      const { data } = await axiosV1.get('/holdingClasses/shares', query);

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
